/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Sku_CodeInputs */

const en_field_sku_code = /** @type {(inputs: Field_Sku_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU code`)
};

/**
* | output |
* | --- |
* | "SKU code" |
*
* @param {Field_Sku_CodeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_sku_code = /** @type {((inputs?: Field_Sku_CodeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Sku_CodeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_sku_code(inputs)
});